import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEditPhone.styl';



/**
 * @emits onClickConfirm {}
 * @emits onInputPhone {string}
 */
Vue.component('BXmakerAuthuserphoneEditPhone',
    {
        props: {
            loader: {
                type: Boolean,
                default : false,
            },
            phone: {
                type: [String],
                default : '',
            },
            phoneError: {
                type: [String, Boolean],
                default : false,
            }
        },
        data: function () {
            return {

            };
        },
        computed: {
            buttonText() {
                if (this.$root.confirmType === this.$root.const.CONFIRM_TYPE_SMS_CODE) {
                    return this.$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_PHONE_BUTTON_GET_CODE;
                } else {
                    return this.$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_PHONE_BUTTON_CONFIRM;
                }
            }
        },
        methods: {
            onInputPhone(value) {
                this.$emit('onInputPhone', value);
            },
            onClickConfirm() {
                this.$emit('onClickConfirm');
            },
            onCompleteCaptcha() {
                this.onClickConfirm();
            },
            onChangePhone(data){
                this.$emit('onInputPhone',data.formattedValue);
            }
        },
        template: `
            <div class="bxmaker-authuserphone-edit-phone">    
                          
                  <slot name="header">
                      <BXmakerAuthuserphoneHeader>
                          {{$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_PHONE_TITLE}}                        
                      </BXmakerAuthuserphoneHeader>
                  </slot>
                  
                   <slot name="currentPhone">
                        <div class="bxmaker-authuserphone-edit-phone__current">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_CURRENT_PHONE}}         
                            <span>{{$root.currentPhone}}</span>
                        </div>
                   </slot>
                              
                   <slot name="message" />  
                        <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" />
                   </slot>     
                                 
                    <slot name="phone">     
                        <BXmakerAuthuserphoneInputPhone  v-if="$root.isEnabledPhoneMaskTypeBitrix"
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_PHONE_INPUT_LABEL" 
                           :value="phone" 
                            @onChange="onChangePhone" 
                            @onEnter="onClickConfirm" 
                            name="PHONE" 
                            :mask="$root.phoneMaskParams"
                            :validationMessage="phoneError"                        
                        /> 
                                  
                        <BXmakerAuthuserphoneInput v-else
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_PHONE_INPUT_LABEL" 
                            :value="phone" 
                            @onInput="onInputPhone" 
                            @onEnter="onClickConfirm" 
                            name="PHONE" 
                            :validationMessage="phoneError"
                            :mask="$root.phoneMaskParams"
                            type="tel"
                        />
                    </slot>
                    
                     <slot name="captcha">
                        <BXmakerAuthuserphoneCaptcha 
                            :code="$root.captchaCode"
                            :src="$root.captchaSrc"
                            :length="$root.captchaLength"
                            :loader="$root.captchaLoader"
                            @onInput="$root.setCaptchaCode"
                            @onComplete="onCompleteCaptcha"
                            @onRefresh="$root.refreshCaptcha"
                           />  
                     </slot>   
                     
                    
                     <slot name="request">
                        <BXmakerAuthuserphoneButton 
                            :title="buttonText"  
                            :loader="loader"
                            @onClick="onClickConfirm" 
                        />
                    </slot>
                    
            </div>   
        `,
    });